// removed by extract-text-webpack-plugin
module.exports = {"pie":"pie___2Y1_D","content":"content___rSOd4","legend":"legend___1Vlaa","dot":"dot___P-X_P","line":"line___3hlkn","legendTitle":"legendTitle___1Yfe7","percent":"percent___2z5xd","value":"value___9iTTS","total":"total___1OVsE"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Charts/Pie/index.less
// module id = 432
// module chunks = 0